<template>
  <div class="main-body">
    <div class="header">评估列表</div>
    <div class="out">

      <div class="search2">

        <el-button type="primary" size="mini" @click.native="showSelectElderly">添加</el-button>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border >

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item :label="value.name+':'" v-for="(value,i) in props.row.listCheckinAssessClassDTO" :key="i" >
                <span>（总得分{{value.sumScore}}）</span>
                <el-button type="text" @click="handleInfo(value.listElderlyCheckinAssessItem)">查看详情</el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
        <el-table-column prop="fraction" label="总分"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="创建时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page" style="text-align: left;background-color: #fff;padding: 10px;">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>

    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="closeGetElderly" v-bind:CheckinAssessGroup="CheckinAssessGroup" v-bind:checkinAssessItemCode="checkinAssessItemCode" v-on:getList="getList"></GetElderly>

    <SelectElderly ref="mySelectElderly" v-show="showModalSelectElderly" v-on:closeSelectElderly="closeSelectElderly" v-on:getList="getList"></SelectElderly>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Info from "./Info";

import GetElderly from "./GetElderly";
import SelectElderly from "./SelectElderly";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalInfo:false,
      showModalGetElderly:false,
      showModalEdit:false,

      showModalSelectElderly:false,


      CheckinAssessGroup:[],
      checkinAssessItemCode:[],

      tableData:[],
      totalItems: 0,
      elderlyName:"",
      pageSize:20,
      currentPage:1,

      th:0,


    }
  },
  components:{
    GetElderly,Info,SelectElderly
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    toggleModalAdd:function(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    closeGetElderly: function () {
      this.showModalGetElderly = !this.showModalGetElderly;
    },


    showSelectElderly:function(){
      this.showModalSelectElderly = !this.showModalSelectElderly;
      this.$refs.mySelectElderly.init();
    },
    closeSelectElderly:function(){
      this.showModalSelectElderly = !this.showModalSelectElderly;
    },



    handleInfo(value) {
      this.$refs.myInfo.init(value);
      this.showModalInfo = !this.showModalInfo;
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyCheckinAssess/InsPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyName:this.elderlyName,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    handleDelete(index,row){
      this.$confirm('确定删除此评估吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl+"ElderlyCheckinAssess/Delete",
          data: {
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            timeStr:timeStr,
            elderlyCheckinAssessCode:row.elderlyCheckinAssessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList();
          }else if(response.data.error == 1){
            this.$message.error(response.data.message)
          }
        })

      }).catch(() => {
        //this.$message({type: 'info', message: '已取消删除'});
      });
    },




  }
}
</script>
<style lang="scss" scoped>
.ElderlyCheckinAssess{
  .demo-table-expand /deep/ label {
    display: inline;
    color: #99a9bf;
  }

  .demo-table-expand /deep/ .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
}
</style>
